import type {ILabel} from '../../../../types';

export default {
    auctionHelpTitle: <ILabel>{
        de: 'So bieten Sie in 2 Schritten mit:',
        en: 'How to bid in 2 steps:',
        es: 'Realice su puja en 2 pasos así:',
        fr: 'Comment enchérir en 2 étapes :',
        nl: 'In 2 stappen meebieden:',
        it: 'Come fare un\'offerta in 2 passaggi:',
    },
    auctionHelpStep1: <ILabel>{
        de: 'Gebot abgeben',
        en: 'Place bid',
        es: 'Pujar por esta joya',
        fr: 'Commandez',
        nl: 'Bieden',
        it: 'Invia l\'offerta',
    },
    auctionHelpStep2: <ILabel>{
        de: 'Gebot bestätigen',
        en: 'Confirm bid',
        es: 'Confirmar puja',
        fr: 'Confirmez votre offre',
        nl: 'Bod bevestigen',
        it: 'Conferma l\'offerta',
    }
}